<template>
  <div>
      <app-sub-title>Eventos</app-sub-title>
      <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
